export default __webpack_public_path__ + "static/media/loc-arte-6.f7e0ec0d.webp";